import http from "./http";

export type SearchTrackingEventType = "custom_search" | "custom_near_me" | string;

export type AdminSearchTrackingRecord = {
	id: number;
	eventType: SearchTrackingEventType;
	sessionId?: string | null;
	searchSource?: string | null;
	searchTrigger?: string | null;
	searchStatus?: string | null;
	nearMeStatus?: string | null;
	searchTerm?: string | null;
	searchResultLabel?: string | null;
	searchPlaceId?: string | null;
	searchLat?: string | null;
	searchLng?: string | null;
	searchMode?: string | null;
	searchRadiusM?: number | null;
	errorMessage?: string | null;
	pagePath?: string | null;
	pageLocation?: string | null;
	createdAt: string;
	updatedAt: string;
};

export type AdminSearchTrackingAnalytics = {
	totalEvents: number;
	uniqueSessions: number;
	totalSearches: number;
	successfulSearches: number;
	noResultSearches: number;
	errorSearches: number;
	nearMeRequests: number;
	nearMeSuccess: number;
	bySource: Array<{
		searchSource: string;
		totalEvents: number;
		share: number;
	}>;
	byMode: Array<{
		searchMode: string;
		totalEvents: number;
		share: number;
	}>;
	topSearchTerms: Array<{
		searchTerm: string;
		totalEvents: number;
	}>;
	topResultLabels: Array<{
		searchResultLabel: string;
		totalEvents: number;
	}>;
	dailyTrend: Array<{
		date: string;
		totalEvents: number;
		totalSearches: number;
		successfulSearches: number;
		noResultSearches: number;
		nearMeRequests: number;
	}>;
	recentEvents: Array<{
		id: number;
		eventType: SearchTrackingEventType;
		searchSource?: string | null;
		searchTrigger?: string | null;
		searchStatus?: string | null;
		nearMeStatus?: string | null;
		searchTerm?: string | null;
		searchResultLabel?: string | null;
		searchMode?: string | null;
		createdAt: string;
	}>;
};

const EMPTY_ANALYTICS: AdminSearchTrackingAnalytics = {
	totalEvents: 0,
	uniqueSessions: 0,
	totalSearches: 0,
	successfulSearches: 0,
	noResultSearches: 0,
	errorSearches: 0,
	nearMeRequests: 0,
	nearMeSuccess: 0,
	bySource: [],
	byMode: [],
	topSearchTerms: [],
	topResultLabels: [],
	dailyTrend: [],
	recentEvents: [],
};

export async function getAdminSearchTrackingEvents(params: {
	page?: number;
	perPage?: number;
	eventType?: string;
} = {}): Promise<{
	docs: AdminSearchTrackingRecord[];
	total: number;
	page: number;
	perPage: number;
	analytics: AdminSearchTrackingAnalytics;
}> {
	const { data } = await http.get("/admin/search-tracking-events", { params });
	return {
		docs: (data?.docs || []) as AdminSearchTrackingRecord[],
		total: data?.total || 0,
		page: data?.page || 1,
		perPage: data?.perPage || params.perPage || 20,
		analytics: (data?.analytics || EMPTY_ANALYTICS) as AdminSearchTrackingAnalytics,
	};
}

export { EMPTY_ANALYTICS as EMPTY_SEARCH_TRACKING_ANALYTICS };
